var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingNot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2693V15.2693H1.6155V7.34625C1.6155 6.03975 2.02892 4.89067 2.85575 3.899C3.68275 2.90733 4.73083 2.28975 6 2.04625V1.5C6 1.22217 6.097 0.986083 6.291 0.79175C6.485 0.59725 6.72058 0.5 6.99775 0.5C7.27492 0.5 7.51125 0.59725 7.70675 0.79175C7.90225 0.986083 8 1.22217 8 1.5V2.04625C9.26917 2.28975 10.3173 2.90733 11.1443 3.899C11.9711 4.89067 12.3845 6.03975 12.3845 7.34625V15.2693H14V16.2693H0ZM6.9965 18.8845C6.55133 18.8845 6.17142 18.7263 5.85675 18.41C5.54192 18.0937 5.3845 17.7134 5.3845 17.2693H8.6155C8.6155 17.7168 8.45692 18.0978 8.13975 18.4125C7.82275 18.7272 7.44167 18.8845 6.9965 18.8845Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNot);
export default __webpack_public_path__ + "static/media/setting_not.9b2c753425f9de2cbd86229b3d505716.svg";
export { ForwardRef as ReactComponent };